import { Injectable } from '@angular/core';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { RequestService } from '@core/services/request/request.service';
import { Observable } from 'rxjs';
import { HttpParamsService } from '@core/services/http-params/http-params.service';
import { LoadingIds } from '@shared/constants/loading';
import {
  AcsConsumptionApi,
  ConsumptionInvoicesFilterApi,
  DailyAcsConsumptionApi,
  HousingModelApi,
  MonthlyAcsConsumptionApi,
  RoomModelApi,
} from '@core/api/model/consumption-invoices/consumption-invoices-api.model';

@Injectable({
  providedIn: 'root',
})
export class ApiAcsService {
  constructor(
    private _requestService: RequestService,
    private _httpParamsService: HttpParamsService
  ) {}

  public fetchHousingAcs(genericLoading?: boolean) {
    return this._requestService.get<RequestResponse<Array<HousingModelApi>>>(ApiDirectory.ConsumoInformes.ViviendasAcs({}), {
      loading: genericLoading ?? LoadingIds.FETCH_ACS_HOUSING,
    });
  }

  public fetchRoomsAcs(genericLoading?: boolean) {
    return this._requestService.get<RequestResponse<Array<RoomModelApi>>>(ApiDirectory.ConsumoInformes.HabitacionesAcs({}), {
      loading: genericLoading ?? LoadingIds.FETCH_ACS_ROOMS,
    });
  }

  public fetchDaily(filter: ConsumptionInvoicesFilterApi): Observable<RequestResponse<AcsConsumptionApi<DailyAcsConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.ConsumoInformes.AcsDiario({}), {
      params: this._httpParamsService.toParams(filter),
      hideErrorAlert: true,
      loading: LoadingIds.FETCH_ACS_CONSUMPTION,
    });
  }

  public fetchMonthly(filter: ConsumptionInvoicesFilterApi): Observable<RequestResponse<AcsConsumptionApi<MonthlyAcsConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.ConsumoInformes.AcsMensual({}), {
      params: this._httpParamsService.toParams(filter),
      hideErrorAlert: true,
      loading: LoadingIds.FETCH_ACS_CONSUMPTION,
    });
  }

  public downloadExcelDaily(filter: ConsumptionInvoicesFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.ConsumoInformes.AcsExcelDiario({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }

  public downloadExcelMonthly(filter: ConsumptionInvoicesFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.ConsumoInformes.AcsExcelMensual({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }
}
